var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFetch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7065 6.06032H10.1005V1.01005C10.1005 0.454524 9.646 0 9.09048 0H5.05026C4.49473 0 4.04021 0.454524 4.04021 1.01005V6.06032H2.43423C1.53528 6.06032 1.08076 7.15117 1.71709 7.78751L6.35323 12.4236C6.74715 12.8176 7.38349 12.8176 7.77741 12.4236L12.4135 7.78751C13.0499 7.15117 12.6055 6.06032 11.7065 6.06032ZM0 16.1608C0 16.7164 0.454524 17.1709 1.01005 17.1709H13.1307C13.6862 17.1709 14.1407 16.7164 14.1407 16.1608C14.1407 15.6053 13.6862 15.1508 13.1307 15.1508H1.01005C0.454524 15.1508 0 15.6053 0 16.1608Z",
    fill: "#2B6ED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetch);
export default __webpack_public_path__ + "static/media/fetch.bc5b50fc94e7322135ba437569acf747.svg";
export { ForwardRef as ReactComponent };